// frameWork.js
import React, { lazy, Suspense, useMemo, forwardRef, useState } from 'react';
import { Box, CircularProgress, Typography } from "@mui/material";
import ErrorBoundary from './Error/ErrorBoundary';
import NotFound from './Error/NotFound';
import { useApiUtil } from "@/utils/apiUtil";
import { useSelector } from "react-redux";

const DynamicContent = forwardRef(({ menuId, prgmId, prgmPath, parm, permissions, onCloseTab, onOpenLoadUnloadManagement, onOpenVehicleManagement }, ref) => {
  const userInfo = useSelector((state) => state.user.userInfo);
  const { gfnCallApi } = useApiUtil();
  const sendLog = async (menuId, prgmPath) => {
    try {
      const res = await gfnCallApi({
        method: "post",
        url: "openPrgmLog",
        data: {
            menuId, prgmPath, prgmId
          },
          showMsg: false,
      });
      if(res === null) return false;
    }catch(e) {}
    return true;
  }

  const DynamicComponent = useMemo(() => {
    //console.log("DynamicComponent====", menuId, prgmPath)
    if (!menuId) return null;
   
    /*
    let cateFolder = '';
    switch (menuId[0]) {
      case '1':
        cateFolder = 'community';
        break;
      case '2':
        cateFolder = 'project';
        break;
      case '3':
        cateFolder = 'rpa';
        break;
      case '4':
        cateFolder = 'systemManagement';
        break;
      case '5':
        cateFolder = 'report';
        break;
      default:
        return () => <NotFound />;
    }
    */
    if(userInfo?.PRGM_LOG === "1" && sendLog(menuId, prgmPath) === false) {
      console.log("Log저장 실패");
    }

    //console.log("[OPEN MENU]", `../category/${cateFolder}/${menuId}/${menuId}.js`);
    console.log("[OPEN MENU]", `../category/${prgmPath}`);

    return lazy(() =>
      //import(`../category/${cateFolder}/${menuId}/${menuId}.js`).catch((err) => {
      import(`../category/${prgmPath}`).catch((err) => {
        console.error(`⚠️ 컴포넌트 로딩 실패: ${menuId}`, err);
        return Promise.reject(err);
      })
    );
  }, [menuId]);

  const LoadingFallback = () => (
    <Box
      sx={{
        height: "100%",
        minHeight: 300,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#fff"
      }}
    >
      <CircularProgress size={48} thickness={4} />
      <Typography
        variant="body2"
        sx={{ mt: 2, color: "text.secondary" }}
      >
        로딩 중입니다...
      </Typography>
    </Box>
  );  

  if (!DynamicComponent) return null;

  return (
    <ErrorBoundary key={menuId} fallback={<NotFound />}>
      <Suspense fallback={<LoadingFallback />}>
        <DynamicComponent ref={ref} menuId={menuId} prgmPath={prgmPath} parm={parm} permissions={permissions} onCloseTab={onCloseTab} onOpenLoadUnloadManagement={onOpenLoadUnloadManagement} onOpenVehicleManagement={onOpenVehicleManagement} />
      </Suspense>
    </ErrorBoundary>
  );
});

export default React.memo(DynamicContent);
